export default "__VITE_ASSET__qIDis0Pd__"